export default (value) => {
  if (!(/\w/.test(value))) { // pelo menos 1 caractere valido
    return null
  }

  return value
  .match(/("[^"]+"|[^"\s]+)/g) // extrai frases entre aspas
  .map((v) => {
    const val = v.replace(/["']/g, '').trim() // remove aspas duplas e simples
    return val ? '"' + val + '"' : null
  })
  .filter((val) => {
    return val
  })
  .join(' ')
}



// WEBPACK FOOTER //
// ./src/utils/KeywordSearchSanitize.js